export default __webpack_public_path__ + "static/media/LinkedIn.7a5eab93.png";